import { FC } from "react";

interface NotFoundPageProps {}

const NotFoundPage: FC<NotFoundPageProps> = () => {
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center bg-orange-100">
      <h1 className="text-[64px] font-bold ">Sorry</h1>
      <h3 className="text-3xl font-semibold ">We couldn't find this page</h3>
    </div>
  );
};

export default NotFoundPage;
